import { IconX } from "@tabler/icons-react";
import styles from "../subscriptionPayment.module.css";

export default function CancelPlanLink({ onClick }) {
  return (
    <div className={styles.cancelPlanRow}>
      <button className={styles.cancelPlanLink} onClick={onClick}>
        <IconX size={13} /> Cancel subscription
      </button>
    </div>
  );
}
